<template>
  <el-container>
    <el-header>
      <h2>消息中心</h2>
      <el-button @click="backWorkbench">返回控制台</el-button>
    </el-header>
    <el-main>
      <el-tabs v-model="activeIndex" @tab-click="tabClick">
        <el-tab-pane label="全部消息" name="-1">
        </el-tab-pane>
        <el-tab-pane label="未读消息" name="0"></el-tab-pane>
      </el-tabs>
      <div class="table">
        <el-table

          class="table_width"
          :data="describeNotifyList"
          :expand-row-keys="expandRowKeys"
          @row-click="messagesInfo"
          row-key="id"
          stripe
        >
          <!--              <el-table-column-->
          <!--                type="selection"-->
          <!--                width="55">-->
          <!--              </el-table-column>-->
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="margin-left: 84px">{{ scope.row.content }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="标题内容"
          >
            <template slot-scope="scope">
              <div class="base-cursor__pointer">
                <i v-if="scope.row.receiveStatus === 0" class="el-icon-bell base-color__lightGreen"></i>
                <span class="base-margin__left-10"
                      :class="scope.row.receiveStatus === 0 ? 'base-color__light_blue': 'tableTitleMarginLeft'">{{
                    scope.row.title
                  }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="提交时间"
          >
          </el-table-column>
          <el-table-column
            label="类型"
          >
            <template slot-scope="scope">
              <span>{{ filterNotifyType(scope.row.notifyType) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <el-pagination
          align="right"
          @size-change="handleSizeChange"
          @current-change="onCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableDataTotal"
        >
        </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { getRequest, postRequest } from '@/common/libs/request';

export default {
  name: 'messageInfo',
  data() {
    return {
      activeIndex: '-1',
      describeNotifyList: [],
      pageIndex: 1, // 分页index
      pageLimit: 10, // 每一页条数
      tableDataTotal: 0, // 任务总数
      expandRowKeys: [], // 展开列表
    };
  },
  methods: {
    backWorkbench() {
      window.sessionStorage.removeItem('menuIndex');
      this.$router.push('/workbench');
    },

    tabClick() {
      this.pageIndex = 1; // 分页index
      this.pageLimit = 10; // 每一页条数
      this.tableDataTotal = 0; // 任务总数
      this.expandRowKeys = []; // 展开列表
      this.getDescribeNotifyList();
    },
    /**
     * 获取消息列表
     **/
    getDescribeNotifyList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      getRequest(`/api/eda/common/notify/describeNotifyList?notifyStatusId=${this.activeIndex}&offset=${offset}&limit=${this.pageLimit}`).then((res) => {
        this.describeNotifyList = res?.list || [];
        this.tableDataTotal = res?.total;
      });
    },

    /**
     * 点击title打开详情
     */
    messagesInfo(item) {
      item.receiveStatus = 1;
      postRequest('/api/eda/common/notify/changeNotifyStatus', { notifyStatusId: item.id });
      const result = this.expandRowKeys.some(val => val === item.id);
      if (result) {
        this.expandRowKeys = this.expandRowKeys.filter(val => val !== item.id);
      } else {
        this.expandRowKeys.push(item.id);
      }
    },

    /**
     * 筛选notifyType
     * 1 = 系统通知
     * 2 = 项目通知
     * 3 = 实验通知
     **/
    filterNotifyType(val) {
      switch (val) {
        case 1:
          return '系统通知';
        case 2:
          return '项目通知';
        case 3:
          return '实验通知';
        default:
          return '-';
      }
    },

    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getDescribeNotifyList();
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getDescribeNotifyList();
    },
  },

  mounted() {
    this.getDescribeNotifyList();
  },
};
</script>

<style scoped lang="scss">
.el-container {
  height: 100%;
  background-color: #fff;
  padding: 18px;
}

.el-button {
  width: 128px;
  height: 40px;
  background-color: #0052D9;
  color: #FFFFFF;
}

.el-header {
  display: flex;
  justify-content: space-between;
  height: 40px !important;
  padding: 0 0 0 46px;
}

.el-main {
  padding: 40px 0 0 46px;
}

.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.tableTitleMarginLeft {
  margin-left: 24px;
}

</style>
